import { render, staticRenderFns } from "./MyForm.vue?vue&type=template&id=345caa1e&scoped=true&"
import script from "./MyForm.vue?vue&type=script&lang=js&"
export * from "./MyForm.vue?vue&type=script&lang=js&"
import style0 from "./MyForm.vue?vue&type=style&index=0&id=345caa1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345caa1e",
  null
  
)

export default component.exports